import accessReducer from "Pages/Access/reducer";
import b2bPaymentReducer from "Pages/B2BPaymentPortal/reducer";
import frFormReducer from "Pages/FinanceReceiptForm/reducer";
import generateInvoiceReducer from "Pages/GenerateInvoice/reducer";
import invoiceReducer from "Pages/Invoices/reducer";
import partsInventoryReducer from "Pages/PartsInventoryTab/reducer";
import pimReducer from "Pages/PartsInventoryTool/reducer";
import paymentsFormReducer from "Pages/PaymentForm/reducer";
import paymentsReducer from "Pages/PaymentPortal/reducer";
import qcFormReducer from "Pages/QCForm/reducer";
import { recallReducer } from "Pages/Recall/reducer";
import recall from "Pages/RecallNew/reducer";
import refurbReducer from "Pages/RefurbTool/reducer";
import reportsReducer from "Pages/Reports/reducer";
import reviewReducer from "Pages/ReviewModule/reducer";
import serviceHistoryReducer from "Pages/ServiceHistory/reducer";
import vasCarCategoryReducer from "Pages/UpdateCarCategory/reducer";
import vehiclePagereducer from "Pages/VehicleListingPage/reducer";
import vehicleOnBoardingFormReducer from "Pages/VehicleOnBoardingForm/reducer";
import pipelineReducer from "Pages/VehiclePipeline/reducer";
import vehicleSummaryReducer from "Pages/VehicleSummary/reducer";
import vendorReducer from "Pages/VendorOverview/reducer";
import vendorsTabReducer from "Pages/VendorsTab/reducer";
import warrantyReducer from "Pages/Warranty/reducer";
import workOrderModuleReducer from "Pages/WorkOrderModule/reducer";
import workorderReducer from "Pages/WorkOrdersTab/reducer";
import workorderV2Reducer from "Pages/WorkOrdersV2Tab/reducer";

import appReducer from "App/appReducer";

export const rootReducer = {
  app: appReducer,
  onBoardingFormReducer: vehicleOnBoardingFormReducer,
  vehicle: vehiclePagereducer,
  vehicleSummary: vehicleSummaryReducer,
  vendor: vendorReducer,
  financeForm: frFormReducer,
  qcForm: qcFormReducer,
  recall: recallReducer,
  serviceHistory: serviceHistoryReducer,
  warranty: warrantyReducer,
  pipeline: pipelineReducer,
  newRecall: recall,
  access: accessReducer,
  refurb: refurbReducer,
  reports: reportsReducer,
  pimConfig: pimReducer,
  workorder: workorderReducer,
  workorderV2: workorderV2Reducer,
  parts: partsInventoryReducer,
  invoices: invoiceReducer,
  review: reviewReducer,
  vendorsTab: vendorsTabReducer,
  workOrderModule: workOrderModuleReducer,
  generateInvoice: generateInvoiceReducer,
  paymentsForm: paymentsFormReducer,
  vasCarCategory: vasCarCategoryReducer,
  b2bPayment: b2bPaymentReducer,
  payments: paymentsReducer
};
